export const modalStyle = {
  overlay: {
    position: "fixed",
    zIndex: 1500,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    inset: "auto",
    margin: "auto",
    width: "1047px",
    maxHeight: "95vh",
    overflowY: "auto",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "hidden",
    WebkitOverflowScrolling: "touch",
    borderRadius: "12px",
    outline: "none",
    padding: "0px",
  },
};
